import { IAppContextAction } from '../../../lib/context/BaseContextModels';
import { MarkDispatchedItemAction, MarkPackagesItemAction } from '../../../lib/context/SmartSendContextModels';

export type ItemActionType =
  'MARK-AS-DISPATCHED' | 'MARK-AS-PACKAGED' | 'MARK-AS-UNPACKAGED' | 'MARK-AS-DISPATCHED-RETRY';

export default function SetMarketplaceAction(
  dispatch: (action: IAppContextAction) => void,
  id: string,
  type: ItemActionType
) {
  switch (type) {
    case 'MARK-AS-PACKAGED':
      dispatch(new MarkPackagesItemAction([id], true));
      break;
    case 'MARK-AS-UNPACKAGED':
      dispatch(new MarkPackagesItemAction([id], false));
      break;
    case 'MARK-AS-DISPATCHED':
      dispatch(new MarkDispatchedItemAction([id]));
      break;
    case 'MARK-AS-DISPATCHED-RETRY':
      dispatch(new MarkDispatchedItemAction([id], true)); // Restart the failed dispatch
  }
}
